

import React from 'react';
import { Grid, Icon, Card } from 'semantic-ui-react';


const HelpCard = (props) => {
return (
    <Grid.Column >
        <Card
            style={styles.card}
            href={props.href}
            onClick={props.onTap}
            raised >
            <Card.Header textAlign="center">
                <Icon name={props.icon} size='huge' style={styles.icon}/>
            </Card.Header>
            <Card.Header  as="h2" textAlign="center">
                {props.title}
            </Card.Header>
            <Card.Meta textAlign="center">
        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dum 
            </Card.Meta>
        </Card>
    </Grid.Column >

)
}

const styles = {
    card: {
        borderRadius: "38px",
        padding: 32,
    },
    icon: {
        color:'#59C4B0',
        textAlign:'center'
    },
    title:{
        color: '#4F6271',
        outline: 'none'
    }
}


export default HelpCard

